import { Button, Typography } from '@mui/material';
import { Card } from '../Card';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { getFirstWord, getWithoutFirstWord } from '@client/new/helpers/general';
import { Link } from 'react-router';

export type NewProgramCardProps = {
  text: string;
  buttonText: string;
  to: string;
};

export const NewProgramCard = (p: NewProgramCardProps) => (
  <div className="flex flex-col gap-6 max-w-xs">
    <Card variant="basic" className="flex-1 text-center text-[#8F94A1]">
      <Typography variant="body2">
        <b>{getFirstWord(p.text)}</b> {getWithoutFirstWord(p.text)}
      </Typography>
    </Card>

    <Link to={p.to}>
      <Button className="bg-[#171e33] text-white w-full" variant="contained">
        <FontAwesomeIcon icon={faPlus} className="mr-4" />
        {p.buttonText}
      </Button>
    </Link>
  </div>
);
